<div id="wrapper" [class]="sideBarName">
 

<app-site-header [loginUserData]="loginUserData" ></app-site-header>

       <!-- Sidebar menu-->
  <app-site-side-menu  [loginUserData]="loginUserData" ></app-site-side-menu>
    
<main class="app-content">
        <div class="app-title">
            <!-- *ngIf="!isPostgraduateStudent()" -->
          <div class="prograssBar" *ngIf="!isPostgraduateStudent" >
            <!-- <h1><i class="fa fa-feed"></i> Progress</h1> -->
           
            <p [class]="completionState.textClass">Current Progress State: {{completionState.message}}</p>
            <div class="bs-component">
                <div class="progress mb-2">
                  <div [class]="completionState.progressClass" role="progressbar"
                   aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" [style.width.%]="completionState.value"></div>
                </div>
              </div>
          </div>
   
        </div>
      
        <router-outlet></router-outlet>
      
</main>



   
              
<app-site-footer></app-site-footer>
         
</div>